import { useSelector } from 'react-redux'
import { RootState } from '../redux'

export default function useProjectAlertRules() {
  return useSelector((state: RootState) => state.projects.projectAlertRules)
}
